import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { ProductColorsState } from '../types'
import featureStateSelector from './featureStateSelector'

export const errorSelector = createSelector<ReduxState, ProductColorsState, string | undefined>(
  featureStateSelector,
  state => state.UIState.error
)
